<template>
  <div class="home">
    <Navbar id="navbar"></Navbar>
    <div id="pagebody" class="container">
      <ProjectionChart id="projectionchart"></ProjectionChart>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//test comment 2
import firebase from 'firebase/app'

require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/storage');

import HelloWorld from '@/components/HelloWorld.vue'
import Navbar from '@/components/Navbar'
import Holdingtable from '@/components/Holdingtable'
import ProjectionChart from '@/components/ProjectionChart'

export default {
  name: 'investments',
  components: {
    HelloWorld,
    Navbar,
    Holdingtable,
    ProjectionChart 
  },
  data () {
      return {
        
      }
    },
    mounted () {
      
    },
  methods:{
    logout: function(){
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
    
  }

}
</script>

<style>
#navbar {
  margin-bottom: 80px;
}


</style>
